/**
 * @file Contains customization for MuiSvgIcon Component
 */

import { Components } from '@mui/material';

const MuiSvgIcon: Components['MuiSvgIcon'] = {
  styleOverrides: {
    root: {
      variants: [
        {
          props: { fontSize: 'tiny' },
          style: {
            '&.MuiSvgIcon-root': {
              fontSize: 'var(--size-mui-icon-tiny)',
            },
          },
        },
      ],
    },
  },
};

export default MuiSvgIcon;
